import { IInitialState } from 'src/store/initialState';

const allCreditCardSel = (state: IInitialState): IInitialState['creditcard'] =>
  state.creditcard;

export const savedCreditCardsSel = (state: IInitialState) =>
  allCreditCardSel(state).savedCards;
export const selectedCardSel = (state: IInitialState) =>
  allCreditCardSel(state).selectedCard;
export const creditCardIsPendingSel = (state: any) =>
  allCreditCardSel(state).isPending;
export const creditCardErrorSel = (state: any) => allCreditCardSel(state).error;
export const creditCardSuccessSel = (state: any) =>
  allCreditCardSel(state).success;
